import type { ClientAddressLookupResult } from '@fv/client-types'

import { BillingAddressForm } from './BillingAddressForm'
import { CustomsBrokerAddressForm } from './CustomsBrokerAddressForm'
import { ShippingAddressForm } from './ShippingAddressForm'
import type { AddressBookListConfig } from './types'

type Props = {
  config: AddressBookListConfig
  initialValues?: ClientAddressLookupResult
}
export const AddressForm = ({ config, initialValues }: Props) => {
  if (config.type === 'customs-broker') {
    return <CustomsBrokerAddressForm initialValue={initialValues} />
  }

  if (config.type === 'billing') {
    return <BillingAddressForm initialValue={initialValues} />
  }

  return (
    <ShippingAddressForm
      initialValues={initialValues}
      context={config.context}
    />
  )
}
